(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('SegmentFieldDeleteController',SegmentFieldDeleteController);

    SegmentFieldDeleteController.$inject = ['$uibModalInstance', 'entity', 'SegmentField'];

    function SegmentFieldDeleteController($uibModalInstance, entity, SegmentField) {
        var vm = this;

        vm.segmentField = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SegmentField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
